export default "__VITE_ASSET__CoitYGOR__"